import { authorizedApi } from './index';

export const bulkOrdersApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    createBulkOrder: builder.mutation({
      query: ({
        imageUrl,
        physicalImageUrl,
        imageUpload,
        physicalImageUpload,
        giftCardsQuantity,
        tokenSymbol,
        tokenAmount,
        recipientName,
        address1,
        address2,
        city,
        state,
        zip,
        country,
        shipMethod,
      }) => ({
        url: `/cps/create-bulk-order`,
        method: 'POST',
        body: {
          imageUrl,
          physicalImageUrl,
          imageUpload,
          physicalImageUpload,
          giftCardsQuantity,
          tokenSymbol,
          tokenAmount,
          recipientName,
          address1,
          address2,
          city,
          state,
          zip,
          country,
          shipMethod,
        },
      }),
    }),
    processCpsOrders: builder.mutation({
      query: () => ({
        url: `/cps/trigger-order-processing`,
        method: 'POST',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useCreateBulkOrderMutation, useProcessCpsOrdersMutation } =
  bulkOrdersApi;
